import React from 'react';
import Meta from './meta';

function NotFound() {
  return (
    <div className="container py-5 my-5">
      <Meta is404={true} />
      <div className="row align-items-center justify-content-center">
        <div className="col-md-8 col-lg-6 text-center">
          <div className="card shadow-sm p-5 border-0 rounded-lg">
            <div className="display-1 font-weight-bold text-primary mb-3">404</div>
            <h1 className="h3 font-weight-bold mb-3">Oops! Requested Page Not Found</h1>
            <p className="text-muted mb-4">
              The project or page you are looking for might have been moved or doesn't exist.
            </p>
            <div>
              <a className="btn btn-primary btn-lg rounded-pill px-4 shadow-sm" href="/">
                &larr; Return to Homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
